/* eslint-disable react/jsx-props-no-spreading */
import type * as React from 'react';
import classNames from 'classnames';
import { Button } from '@doda/io-react/common';
import type { JobResponse } from '@doda/api-client/aspida/@types';
import { JOB_OFFER_KIND_TYPE_AGENT } from '../../constants';
import styles from './index.module.scss';

type IOButtonProps = React.ComponentProps<typeof Button>;

/**
 * CommonApplyButtonProps
 */
export interface CommonApplyButtonProps
  extends Pick<IOButtonProps, 'widthPercentage' | 'size' | 'onClick'> {
  /** デザインシステム定義サイズを指定 */
  size: 'S' | 'M' | 'L';
  /** クリック時に実行する処理  */
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}

const DirectApplyButton = (props: CommonApplyButtonProps) => {
  return (
    <Button variant="blue" {...props}>
      応募する
    </Button>
  );
};

const AgentApplyButton = (props: CommonApplyButtonProps) => {
  const { size } = props;
  return (
    <Button variant="orange" {...props}>
      <span>
        応募依頼する
        <span
          className={classNames(
            styles['jobSearchDetail-applyButton__subText'],
            {
              [styles['jobSearchDetail-applyButton__subText--L']]: size === 'L',
              [styles['jobSearchDetail-applyButton__subText--S']]: size === 'S',
            }
          )}
        >
          （エージェントサービス）
        </span>
      </span>
    </Button>
  );
};

/**
 * ApplyButtonProps
 */
export interface ApplyButtonProps
  extends Omit<CommonApplyButtonProps, 'widthPercentage'> {
  /** 求人種別 */
  jobOfferKind: JobResponse['jobOfferKind'];
  /** 任意の幅を指定 */
  width?: React.CSSProperties['width'];
}

/** 応募ボタンUI */
export const ApplyButton = (props: ApplyButtonProps) => {
  const { jobOfferKind, width, size, onClick } = props;
  const isAgent = jobOfferKind === JOB_OFFER_KIND_TYPE_AGENT;
  const buttonProps: CommonApplyButtonProps = {
    size,
    widthPercentage: width ? 100 : undefined,
    onClick,
  };

  return (
    <div style={{ width }}>
      {isAgent ? (
        <AgentApplyButton {...buttonProps} />
      ) : (
        <DirectApplyButton {...buttonProps} />
      )}
    </div>
  );
};
